import { BidderSeat } from '@pubstack/common/src/bidder-seat'
import { CARD_INTEGRATION_ICON } from '~/components/catalog/ModuleCard'
import { IconName } from '~/components/Icon'

/** How the seat is integrated. The product it belongs to is a separate column now that the list holds both. */
export const seatTypeLabel = (seat: BidderSeat): string => {
  switch (seat.type) {
    case 'node':
      return 'Server-side'
    case 'spark_for_pubs':
      return 'Spark for Pubs'
    case 'spark_demand':
      return 'Spark Demand'
    case 'adm':
      return seat.platform === 'client' ? 'Client-side' : 'Server-side One (legacy)'
    // A seat written before the type rename would otherwise render an empty cell.
    default:
      return seat.type
  }
}

/**
 * The glyph that goes on a seat-type chip, taken from the catalog's own integration icons so a seat and
 * the card it was created from are marked the same way.
 *
 * The deprecated server-side seat borrows the current one's glyph: it is the same integration, and the
 * label already carries the only thing that separates them.
 */
export const seatTypeIcon = (seat: BidderSeat): IconName | undefined => {
  switch (seat.type) {
    case 'node':
      return CARD_INTEGRATION_ICON['Server-side']
    case 'spark_for_pubs':
      return CARD_INTEGRATION_ICON['Spark for Pubs']
    case 'spark_demand':
      return CARD_INTEGRATION_ICON['Spark Demand']
    case 'adm':
      return seat.platform === 'client' ? CARD_INTEGRATION_ICON['Client-side'] : CARD_INTEGRATION_ICON['Server-side']
    default:
      return undefined
  }
}
